// removed by extract-text-webpack-plugin
module.exports = {"multiple-choice-wrapper":"MultipleChoiceField__multiple-choice-wrapper___2UYYs"};